export const EMAIL_ARCHIVE_STATUS = 'email_archive';
export const EMAIL_ARCHIVE_STATUS_COLUMNS = [
  { label: 'ID', columnName: 'backupId' },
  { label: 'Journal ID', columnName: 'journalId', size: 'sm' },
  { label: 'Journal Host', columnName: 'journalHost', size: 'sm' },
  {
    label: 'Journal Email',
    columnName: 'email',
    size: 'sm',
  },
  {
    label: 'Journal Rule Group',
    columnName: 'ruleGroup',
    size: 'sm',
  },
  {
    label: 'Organization Name',
    columnName: 'organizationName',
    size: 'sm',
  },
  {
    label: 'Partner Name',
    columnName: 'partnerName',
    size: 'sm',
  },
  {
    label: 'Parent Name',
    columnName: 'parentName',
    size: 'sm',
  },
  { label: 'Backup Status', columnName: 'status', size: 'sm' },
  { label: 'Start Backup Time', columnName: 'startTime', size: 'sm' },
  { label: 'End Backup Time', columnName: 'endTime', size: 'sm' },
  { label: 'Backup Storage KB', columnName: 'backupStorage', size: 'sm' },
  { label: 'Compressed Storage', columnName: 'compressedStorage', size: 'sm' },
  { label: 'Current Message Numbers', columnName: 'currentMessagesCount', size: 'sm' },
  { label: 'Total Message Numbers', columnName: 'totalMessagesCount', size: 'sm' },
  { label: 'Retries Time', columnName: 'retries', size: 'sm' },
  { label: 'Error Messages', columnName: 'errorMessage', size: 'sm' },
  { label: 'Run on Machine IP', columnName: 'machineIP', size: 'sm' },
  { label: 'Created At', columnName: 'createdAt', size: 'sm' },
  { label: 'Last Data Updated At', columnName: 'updatedAt', size: 'sm' },
];
